import { call, put, takeLatest } from "redux-saga/effects";
import { schema } from "normalizr";
import { authorizedRequest, downloadFile } from "utils/api";

export const FORWARD_CURVE_GET_REQUEST = "FORWARD_CURVE_GET_REQUEST";
export const FORWARD_CURVE_GET_FAILURE = "FORWARD_CURVE_GET_FAILURE";
export const FORWARD_CURVE_GET_SUCCESS = "FORWARD_CURVE_GET_SUCCESS";

export const FORWARD_CURVE_RESET_REQUEST = "FORWARD_CURVE_RESET_REQUEST";
export const FORWARD_CURVE_RESET_FAILURE = "FORWARD_CURVE_RESET_FAILURE";
export const FORWARD_CURVE_RESET_SUCCESS = "FORWARD_CURVE_RESET_SUCCESS";

export const FORWARD_CURVE_DOWNLOAD_REQUEST = "FORWARD_CURVE_DOWNLOAD_REQUEST";
export const FORWARD_CURVE_DOWNLOAD_FAILURE = "FORWARD_CURVE_DOWNLOAD_FAILURE";

export const FORWARD_CURVE_KEY = "forwardCurve";
export const FORWARD_CURVE_ENTITY = new schema.Entity(FORWARD_CURVE_KEY, {});
export const FORWARD_CURVE_SCHEMA = [FORWARD_CURVE_ENTITY];

const initialState = {};

export default function forwardCurveReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case FORWARD_CURVE_GET_SUCCESS:
      return {
        ...payload
      };

    case FORWARD_CURVE_RESET_SUCCESS:
      return {
        ...payload
      };

    default:
      return state;
  }
}

// GET ForwardCurve
export function getForwardCurve(payload) {
  return {
    type: FORWARD_CURVE_GET_REQUEST,
    payload
  };
}
export function getForwardCurveSuccess(payload) {
  return {
    type: FORWARD_CURVE_GET_SUCCESS,
    payload
  };
}
export function getForwardCurveFailure(error) {
  return {
    type: FORWARD_CURVE_GET_FAILURE,
    error
  };
}

// Reset ForwardCurve
export function resetForwardCurve(payload) {
  return {
    type: FORWARD_CURVE_RESET_REQUEST,
    payload
  };
}
export function resetForwardCurveSuccess(payload) {
  return {
    type: FORWARD_CURVE_RESET_SUCCESS,
    payload
  };
}
export function resetForwardCurveFailure(error) {
  return {
    type: FORWARD_CURVE_RESET_FAILURE,
    error
  };
}

// Download ForwardCurve
export function downloadForwardCurve(payload) {
  return {
    type: FORWARD_CURVE_DOWNLOAD_REQUEST,
    payload
  };
}
export function downloadForwardCurveFailure(error) {
  return {
    type: FORWARD_CURVE_DOWNLOAD_FAILURE,
    error
  };
}

// Saga GET ForwardCurve
function* getForwardCurveSaga() {
  try {
    const response = yield call(
      authorizedRequest,
      "/calculators/forwardcurve",
      "GET"
    );
    yield put(getForwardCurveSuccess(response));
  } catch (error) {
    yield put(getForwardCurveFailure(error));
  }
}

// Saga GET ForwardCurve
function* resetForwardCurveSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/calculators/forwardcurve?reset=${payload.payload.day}&curve=${
        payload.payload.curve
      }`,
      "GET"
    );
    yield put(resetForwardCurveSuccess(response));
  } catch (error) {
    yield put(resetForwardCurveFailure(error));
  }
}

// Saga GET ForwardCurve
function* downloadForwardCurveSaga(payload) {
  try {
    yield call(
      downloadFile,
      `calculators/forwardcurve?reset=${payload.payload.day}&curve=${
        payload.payload.curve
      }&download=true`,
      "GET"
    );
  } catch (error) {
    yield put(downloadForwardCurveFailure(error));
  }
}

export function* forwardCurveSaga() {
  yield takeLatest(FORWARD_CURVE_GET_REQUEST, getForwardCurveSaga);
  yield takeLatest(FORWARD_CURVE_RESET_REQUEST, resetForwardCurveSaga);
  yield takeLatest(FORWARD_CURVE_DOWNLOAD_REQUEST, downloadForwardCurveSaga);
}
